import axiosClient from '../../configs/axios';


class IndustryMasterService {
    // Get list 
    async getIndustryList(params) {
        try {
            const response = await axiosClient.get(
                `/industry/list?page=${params.page}&&size=${params.size}&&searchKey=${params.searchKey}`
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    // Add 
    async addIndustry(data) {
        try {
            const response = await axiosClient.post('/industry/add', data);
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    // Edit or delete
    async editDeleteIndustry(data) {
        try {
            const response = await axiosClient.put(`/industry/editDelete`, data);
            return response.data;
        } catch (error) {
            throw error;
        }
    }
}

export default new IndustryMasterService(); 